import { Loading } from './PageLoading';
export * from './PageLoading';
export default Loading;
